export default __webpack_public_path__ + "static/media/world_.c1f5c065.png";